import {
  toCamelCase,
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSPanel,
  WSRadioInput,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { ReactNode } from "react";

type OnboardingOptionProps = Omit<WSElementProps, "title"> & {
  name: string;
  value: string;
  title?: ReactNode;
  checked?: boolean;
};

export const OnboardingOption: React.FC<OnboardingOptionProps> = ({
  name,
  value,
  children,
  title,
  checked,
  ...elementProps
}) => (
  <WSPanel
    as="label"
    {...{ ...elementProps, for: `${name}_${value}` }}
    style={{ cursor: "pointer" }}
    data-testid={toCamelCase(name, value, "option")}
  >
    <WSFlexBox.CenterY wrap="nowrap">
      <WSRadioInput
        id={`${name}_${value}`}
        value={value}
        name={name}
        mr="S"
        checked={checked}
      />
      <WSElement>
        {title && <WSText.Heading4 mb="XS">{title}</WSText.Heading4>}
        {children}
      </WSElement>
    </WSFlexBox.CenterY>
  </WSPanel>
);
